import { useMemo } from "react";
import { Select } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

const FuelTypeSelect = ({
  value,
  onChange,
  isRequired,
}: {
  value?: string;
  onChange?: (value: string) => void;
  isRequired?: boolean;
}) => {
  const { t } = useTranslation();

  const fuelTypeOptions = useMemo(
    () => [
      { label: " - ", value: "" },
      { label: t("fuel_type_benzinas"), value: "Benzinas" },
      { label: t("fuel_type_benzinas_elektra"), value: "Benzinas + Elektra" },
      { label: t("fuel_type_dyzelinas"), value: "Dyzelinas" },
      { label: t("fuel_type_dyzelinas_elektra"), value: "Dyzelinas + Elektra" },
      { label: t("fuel_type_elektra"), value: "Elektra" },
    ],
    [t]
  );

  const handleChange = (selectedValue: string) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <div>
      <Select
        label={t("fuel_type")}
        options={fuelTypeOptions}
        onChange={handleChange}
        value={value || ""}
        requiredIndicator={isRequired ? true : false}
        error={isRequired && !value ? t("field_is_required") : ""}
      />
    </div>
  );
};

export default FuelTypeSelect;
